// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + "index" + "." + "68153ff279c1c73bcb57" + ".css";
};